"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestaurantDeliveryType = void 0;
var RestaurantDeliveryType;
(function (RestaurantDeliveryType) {
    RestaurantDeliveryType["Dinein"] = "dinein";
    RestaurantDeliveryType["Delivery"] = "delivery";
    RestaurantDeliveryType["Pickup"] = "pickup";
})(RestaurantDeliveryType = exports.RestaurantDeliveryType || (exports.RestaurantDeliveryType = {}));
var initState = {
    restaurant: {},
    categories: [],
    type: null,
    loading: false,
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case "restaurant/SET_TYPE":
            return __assign(__assign({}, state), { type: action.data });
        case "restaurant/LOAD_DATA":
            return __assign(__assign({}, state), { loading: true });
        case "restaurant/LOAD_DATA_SUCCESS":
            return __assign(__assign({}, state), { loading: false, restaurant: action.restaurant });
        case "restaurant/LOAD_DATA_FAILURE":
            return __assign(__assign({}, state), { loading: false });
        case "restaurant/LOAD_MENU":
            return __assign(__assign({}, state), { loading: true });
        case "restaurant/LOAD_MENU_FAILURE":
            return __assign(__assign({}, state), { loading: false });
        case "restaurant/LOAD_MENU_SUCCESS":
            return __assign(__assign({}, state), { loading: false, categories: action.data });
        case "restaurant/CLEAR":
            return initState;
        default:
            return state;
    }
});
